import { useForm } from "react-hook-form";
import { addFamilyInput, addFamilySchema } from "../features/families/familySchema";
import { zodResolver } from "@hookform/resolvers/zod";
import { CardSimple } from "./UI/Card";
import Button from "./UI/Button";
import { Paragraph } from "./UI/Typography";
import AddFamilyFormFields from "./AddFamilyFormFields";

interface Props {
  onSubmit: (data: addFamilyInput) => void;
  isLoading: boolean;
  message: string;
  error: string;
}

const AddFamilyForm = ({ onSubmit, isLoading, message, error }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<addFamilyInput>({
    resolver: zodResolver(addFamilySchema),
  });

  return (
    <CardSimple className="max-w-xl mx-auto mt-10 p-6 space-y-6">
      <h2 className="text-3xl font-bold text-center text-primary">הוספת משפחה</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <AddFamilyFormFields register={register} errors={errors} />
        <Button type="submit" fullWidth isLoading={isLoading}>
          הוסף משפחה
        </Button>

        {message && (
          <Paragraph className="text-success text-center font-semibold">
            {message}
          </Paragraph>
        )}

        {error && (
          <Paragraph className="text-danger text-center font-semibold">
            {error}
          </Paragraph>
        )}
      </form>
    </CardSimple>
  );
};

export default AddFamilyForm;